export function formatNumberForDisplay(value) {
  if (value == null)
    return null

  const locale = document.documentElement.lang || "fr-FR"
  return value.toLocaleString(locale, {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false
  })
}

export function parseLocaleNumber(value) {
  const cleaned = (value || "").toString().replace(/\s/g, "").replace(",", ".")
  const num = parseFloat(cleaned)
  return isNaN(num) ? null : num
}

export function parseUserInput(value) {
  const num = parseLocaleNumber(value)
  return num == null ? null : Math.abs(num)
}

